import {createFileRoute, Outlet} from '@tanstack/react-router'
import ShardIframe from '@/components/ShardIframe'
import ThemeProvider from '@/providers/ThemeProvider'
import MfdProvider from '@/providers/MfdProvider'

// Layout that wraps all /shardlibrary/* routes with the Game context provider and
// the global ShardIframe component (Penpal iframe for rendering shards).
// Replaces the router.asPath.startsWith('/shardlibrary') conditional in Renderer.js.
const ShardLibraryLayout = () => (
	<MfdProvider>
		<ThemeProvider>
			<Outlet/>
			<ShardIframe/>
		</ThemeProvider>
	</MfdProvider>
)

export const Route = createFileRoute('/_auth/shardlibrary')({
	component: ShardLibraryLayout,
})
